import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputDayTimeComponent } from './input-day-time.component';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [InputDayTimeComponent],
  exports: [InputDayTimeComponent],
  imports: [CommonModule, AngularMaterialModule, FormsModule, FlexLayoutModule],
})
export class InputDayTimeModule {}
